import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { useMutation } from '@tanstack/react-query';

const RemoveEmailSignatureMutation = graphql(`
  mutation RemoveEmailSignature {
    removeEmailSignature
  }
`);

export const useRemoveEmailSignature = () => {
  return useMutation({
    mutationFn: () => {
      return gqlClient.request(RemoveEmailSignatureMutation);
    },
  });
};
